import React, { Component, createRef } from 'react';
import './Play.css';
import Nav from '../nav/Nav';
import Mirror from './Mirror';
import Memory from './Memory';
import MenuButton from '../buttons/MenuButton';
import MainButton from '../buttons/MainButton';
import Flowers from '../other/flowers/Flowers';
import User from '../../User';
import Champion from '../cards/Champion';
import Library from '../../scene/utility/Library';
import Img from '../../StableImage';
import CardBox from '../cards/CardBox';
import { EventEmitter } from 'events';
import { Link as DomLink } from "react-router-dom";
import DeckViewer from '../../scene/view/DeckViewer';
import { preload } from '../../SoundManager';
import { Tooltip } from 'reactstrap';
import allcutscenes from '../../library/cutscenes.json';
import CutsceneManager from '../../scene/CutsceneManager';
import Cutscene from '../../scene/view/Cutscene';
import Lightbox from '../utility/Lightbox';

import { read, getLanguage } from '../../TextManager';

const lang = getLanguage();
const cutscenes = {};

Object.values(allcutscenes).forEach(cutscene => {
    const { champion, type, value } = cutscene;

    if (!cutscenes[champion]) {
        cutscenes[champion] = {};
    }

    if (!cutscenes[champion][type]) {
        cutscenes[champion][type] = value ? {} : cutscene;
    }

    if (value) {
        cutscenes[champion][type][value] = cutscene;
    }
});

const OAUTH_CLIENT_ID = "dEwJq9p7qYkYcczZOSplEbA6YEmRRprHDXgI2vKUlh8rT6-nBAf2QbLhCWj9lCLT";
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;

const champions = Object.values(Library.champions);

const countsTowardsDeckSize = card => {
  const model = Library.getUpgradedCard(card.key);
  return !model.locked && !Library.hasSubtype(model, "augment");
};
const deckSize = deck => deck.filter(card => card.status !== "disabled" && countsTowardsDeckSize(card)).length;

const actForRun = run => Library.getAct(run?.act) || Object.values(Library.acts).find(act => act.act === run?.floor);
const roomNumberForRun = run => Math.max(1, Math.min(17, 17 - run.time)) - 1;

export default class Play extends Component {

  cutsceneManager = new CutsceneManager(null, c => this.setState({cutscene: c ? Object.assign({}, this.state.cutscene, c) : null}))

  constructor(props) {
    super(props);
    this.fileInputRef = createRef();
    this.domlink = React.createRef();
    this.difficultyRef = React.createRef();
  }

  state = {
    champion: User.champion,
    noRun: null,
    deck: null,
    tooltip: null
  }

  handleConnectWithPatreon = () => {

    const authorizationUrl = `https://www.patreon.com/oauth2/authorize?response_type=code&client_id=${OAUTH_CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`;
    window.location.href = authorizationUrl;
  };

  setChampion (n) {

    this.setState({champion: n});
    User.champion = n;
    User.shardsChange(User.databank[n][User.difficulty].shards);
  }

  claimRun (claimedRun) {

    let run = claimedRun || this.state.checkContinue;
    let data = User.dataFor(run.champion.model, run.difficultySetting);
    let convertedExpReward = this.convertedExpReward(run);
    if (!run.storyEvent && run.rooms.length > 1)
      User.addRun(run);
    if (run.over && convertedExpReward)
      User.setShards(data.shards + convertedExpReward, run.champion.model, run.difficultySetting);
    User.setBenevolence(data.benevolence + run.addedBenevolence, run.champion.model, run.difficultySetting);
    User.removeItem("run.save");
    User.removeItem("run.log");
  }

  convertedExpReward (run, includeCurrentExp=false) {

    if (!run || run.storyEvent)
      return 0;
    if (includeCurrentExp) {
      const bonus = run.convertedExpBonus || 0;
      return bonus + Math.ceil(Math.max(0, run.champion.gatheredExp) / 2);
    }
    if (run.convertedExpReward !== undefined)
      return run.convertedExpReward;
    return (run.convertedExpBonus || 0) + Math.ceil(Math.max(0, run.champion.gatheredExp) / 2);
  }

  matchingCurrentRun () {

    const currentRun = User.currentRun;
    return currentRun && currentRun.champion.model === this.state.champion ? currentRun : null;
  }

  requestAbandonRun () {

    const currentRun = this.matchingCurrentRun();
    if (!currentRun)
      return;

    this.setState({ checkContinue: currentRun, checkContinueAction: "abandon" });
  }

  abandonRun () {

    if (!this.state.checkContinue)
      return;

    const forfeitedRun = Object.assign(
      Object.create(Object.getPrototypeOf(this.state.checkContinue)),
      this.state.checkContinue,
      { over: true }
    );
    this.claimRun(forfeitedRun);
    this.setState({ checkContinue: false, checkContinueAction: null });
  }

  getRunDifficulty (run=this.state.checkContinue) {

    return run && (run.difficultySetting || run.difficulty);
  }

  continueRun () {

    const difficulty = this.getRunDifficulty(this.state.checkContinue || this.matchingCurrentRun());
    if (difficulty)
      User.difficulty = difficulty;
  }

  getDifficultyName (difficulty) {

    return {
      zen: "Zen",
      casual: "Casual",
      challenge: "Challenge",
      hardcore: "Hardcore"
    }[difficulty] || difficulty;
  }

  embark (floor=1) {

    if (this.state.embarking)
      return;

    if (!User.getItem("difficulty")) {
      this.difficultyRef.current?.open(() => this.embark());
      return;
    }

    if (User.currentRun && !this.state.checkContinue) {
      this.setState({ checkContinue: JSON.parse(User.getItem("run.save")) });
      return;
    } else if (User.currentRun)
      this.claimRun();

    this.setState({checkContinue: false, embarking: true});
    User.removeItem("run.save");
    User.removeItem("run.log");
    User.setItem("champion.select", this.state.champion);
    localStorage.setItem("run.floor", floor);
    localStorage.removeItem("run.event");
    setTimeout(() => document.getElementsByClassName("main-page")[0].classList.add("fade-out"), 1500);
    setTimeout(() => this.domlink.current.click(), 2000);
    [
      "Tenno - The Guiding Wind",
      "BVG - Gilded Voyage",
      "Tenno - Sacred Tree",
      "Tenno - Between Worlds",
      "BVG - Sacred Land"
    ].forEach(track => preload(track));
  }

  challengeMemory () {


    if (this.state.embarking)
      return;

    const quest = this.quest;

    if (User.currentRun && !this.state.checkContinue) {
      this.setState({ checkContinue: JSON.parse(User.getItem("run.save")) });
      return;
    } else if (User.currentRun)
      this.claimRun();
      
    this.setState({checkContinue: false, embarking: true});
    
    User.removeItem("run.save");
    User.removeItem("run.log");
    User.setItem("champion.select", this.state.champion);
    localStorage.setItem("run.event", JSON.stringify({
      "enemies": quest.enemies,
      "background": quest.background,
      "audio": quest.audio,
      "deck": this.state.deck.filter(card => card.status !== "disabled").map(card => card.key),
      "relics": User.data.stats.runs[this.state.noRun].relics || [],
      "companion": User.data.stats.runs[this.state.noRun].companion,
      "minDeckSize": User.data.stats.runs[this.state.noRun].minDeckSize,
      "startingLevel": this.questLevel,
      "memory": true
    }));
    localStorage.removeItem("run.floor");
    document.getElementsByClassName("main-page")[0].classList.add("fade-out")
    setTimeout(() => this.domlink.current.click(), 500);
    [
      "amber",
      "ruby",
      "pearl",
      "beryl",
      "spinelle"
    ].forEach(track => preload(track));
  }

  challenge () {

    if (this.state.embarking)
      return;

    const quest = User.dataQuest;

    if (User.currentRun && !this.state.checkContinue) {
      this.setState({ checkContinue: JSON.parse(User.getItem("run.save")) });
      return;
    } else if (User.currentRun)
      this.claimRun();
      
    this.setState({checkContinue: false, embarking: true});

    User.removeItem("run.save");
    User.removeItem("run.log");
    User.setItem("champion.select", this.state.champion);
    localStorage.setItem("run.event", JSON.stringify({
      "enemies": quest.enemies,
      "background": quest.background,
      "audio": quest.audio,
      "deck": this.state.deck.filter(card => card.status !== "disabled").map(card => card.key),
      "relics": User.data.stats.runs.filter(run => run.stats.level >= User.data.level)[this.state.noRun].relics || [],
      "companion": User.data.stats.runs.filter(run => run.stats.level >= User.data.level)[this.state.noRun].companion,
      "minDeckSize": User.data.stats.runs.filter(run => run.stats.level >= User.data.level)[this.state.noRun].minDeckSize
    }));
    localStorage.removeItem("run.floor");
    document.getElementsByClassName("main-page")[0].classList.add("fade-out")
    setTimeout(() => this.domlink.current.click(), 500);
    [
      "amber",
      "ruby",
      "pearl",
      "beryl",
      "spinelle"
    ].forEach(track => preload(track));
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTouch = touch;
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  render () {

    const champion = this.state.champion;
    const matchingCurrentRun = this.matchingCurrentRun();
    const checkContinueDifficulty = this.getRunDifficulty();
    const abandonConvertedExpReward = this.state.checkContinueAction === "abandon" ? this.convertedExpReward(this.state.checkContinue, true) : 0;

    const locked = !User.premium && Library.getChampion(champion).levelLimit === 0;
    const softMode = User.isFetishSoft(champion);

    const level = User.data.level;

    let finalLevel = 1;
    const shrinkChibisToLv1 = champions[champion-1].chibi.filter(chibi => chibi.from <= level);
    const shrinkChibis = shrinkChibisToLv1.filter((chibi,i) => i >= shrinkChibisToLv1.length-1 || shrinkChibisToLv1[i+1].from > finalLevel)
    while (shrinkChibis.length > 3)
      shrinkChibis.splice(-2, 1);
    const minShrinkChibiIndex = shrinkChibisToLv1.length - shrinkChibis.length;

    let scaleIndex = 0;
    while (scaleIndex+1 < champions[champion-1].scale.length && champions[champion-1].scale[scaleIndex+1].from <= level)
      scaleIndex++;
    let scale = champions[champion-1].scale[scaleIndex].value;

    let eventRuns = this.state.memory ? User.data.stats.runs : User.data.stats.runs.filter(run => run.stats.level >= User.data.level);

    return (
      <div className={"main-page play-page champion-" + champion}>
        {
          this.state.cardbox ?
          <div>
            <CardBox level={User.data.level} src={champions[champion-1]} open={true} onClose={() => this.setState({cardbox:null})}/>
          </div>
          : ""
        }
        <Flowers/>
        <Nav onChangeDifficulty={() => this.forceUpdate()} difficultyRef={this.difficultyRef}/>
        {
          this.state.warning &&
          <Lightbox className="lightbox-warning" open={ true } onClose={ () => this.setState({warning: null, warninginfo: null}) }>
            <div className="options-warning">{this.state.warning}</div>
            { this.state.warninginfo && <div className="options-info">{this.state.warninginfo}</div> }
          </Lightbox>
        }
        {
          !locked && this.state.checkContinue &&
          <Lightbox className="check-continue" open={ true } onClose={ () => this.setState({checkContinue: false, checkContinueAction: null}) }>
            <h1>{read('menu/currentrun')}</h1>
            <div className="check-continue-main">
              <div className="check-continue-description">
                <div className="check-continue-stat">
                  <div className="check-continue-stat-image"><Img src="/images/mazepower.png"/></div>
                  <div className="check-continue-stat-value">{ this.state.checkContinue.power }</div>
                </div>
                <div className="check-continue-stat">
                  <div className="check-continue-stat-image"><Img src={"/images/acts/" + (actForRun(this.state.checkContinue)?.key || "ruins") + ".png"}/></div>
                  <div className="check-continue-stat-value">{ roomNumberForRun(this.state.checkContinue) }</div>
                </div>
                <div className="check-continue-stat">
                  <div className="check-continue-stat-image"><Img src="/images/entropy.png"/></div>
                  <div className="check-continue-stat-value">{ this.state.checkContinue.minDeckSize }</div>
                </div>
                <div className="check-continue-stat">
                  <div className="check-continue-stat-image"><Img src="/images/health.png"/></div>
                  <div className="check-continue-stat-value">{ this.state.checkContinue.champion.hp }</div>
                </div>
                <div className="check-continue-stat">
                  <div className="check-continue-stat-image"><Img src="/images/exp.png"/></div>
                  <div className="check-continue-stat-value">{ this.state.checkContinue.champion.gatheredExp }</div>
                </div>
                <div className="check-continue-stat">
                  <div className="check-continue-stat-image"><Img src="/images/gold.png"/></div>
                  <div className="check-continue-stat-value">{ this.state.checkContinue.champion.gold }</div>
                </div>
                <div className="check-continue-stat">
                  <div className="check-continue-stat-image"><Img src="/images/treasure.png"/></div>
                  <div className="check-continue-stat-value">{ (this.state.checkContinue.champion.relics || []).length }</div>
                </div>
              </div>
              <div className="check-continue-image">
                <Champion src={champions[this.state.checkContinue.champion.model-1]} level={this.state.checkContinue.champion.level}/>
                <div className="play-champion-level">{read('scene/lv') + this.state.checkContinue.champion.level}</div>
              </div>
            </div>
            {
              checkContinueDifficulty &&
              <div className={"check-continue-difficulty " + checkContinueDifficulty + "-setting"}>
                <Img src={"/images/" + checkContinueDifficulty + ".png"}/>
                <span>{this.getDifficultyName(checkContinueDifficulty)}</span>
              </div>
            }
            {
              this.state.checkContinueAction === "abandon" ?
              <div className="check-continue-stat abandon-run-reward">
                <div className="check-continue-stat-image"><Img src="/images/soulshard.png"/></div>
                <div className="check-continue-stat-label">{abandonConvertedExpReward + " " + read('scene/resultshards')}</div>
              </div> :
              <div className="options-warning">{read('menu/newrunwarning')}</div>
            }
            <div className="check-continue-buttons">
              <MainButton onClick={() => {
                if (this.state.checkContinueAction === "abandon")
                  this.abandonRun();
                else if (this.state.noRun !== null && !this.state.memory)
                  this.challenge();
                else if (this.state.memory)
                  this.challengeMemory();
                else
                  this.embark();
              }} color="red">{this.state.checkContinueAction === "abandon" ? read('menu/abandonrun') : (this.state.noRun !== null ? read('menu/storyfight') : (this.state.memory ? "Fight" : read('menu/newrun')))}</MainButton>
              <MainButton onClick={() => this.continueRun()} to="/game">{read('menu/continuerun')}</MainButton>
            </div>
          </Lightbox>
        }
        { !locked && !softMode && this.state.mirror && <Mirror champion={this.state.champion} onClose={() => this.setState({mirror: null})}/> }
        { !locked && this.state.memory && <Memory play={this} champion={this.state.champion} progress={Math.min(User.data.progress, this.state.champion !== 5 ? 4 : 3)} onPickQuest={(quest, level) => {
          this.quest = quest;
          this.questLevel = level;
          if (eventRuns.length > 0)
            this.setState({noRun: User.data.stats.runs.length-1, deck: User.data.stats.runs[User.data.stats.runs.length-1].deck.map(card => Object.assign({}, card))});
          else
            this.setState({warning: read('menu/storyfightmissingdeckwarning'), warninginfo: read('menu/storyfightmissingdeckinfo')});
        } } onClose={() => this.setState({memory: null})}/> }
        <div className="main">
          <div className="play-champion">
            <div style={{transform: "scale(" + scale + ")"}} className="play-champion-inner" onClick={() => this.setState({cardbox:true})}><Champion src={champions[champion-1]}/></div>
            <div onClick={() => this.setChampion(this.state.champion == 1 ? champions.length : this.state.champion - 1)} className="cardbox-arrow cardbox-arrow-left"><Img alt="" src="/images/arrowhead.png"/></div>
            <div onClick={() => this.setChampion(this.state.champion % champions.length + 1)} className="cardbox-arrow cardbox-arrow-right"><Img alt="" src="/images/arrowhead.png"/></div>
            <div className="play-champion-name">{champions[champion-1].translations[lang].name}</div>
            <div className="play-champion-level">{read('scene/lv') + level}</div>
            { !locked && User.data.progress > 1 && <div className="play-social play-interact" onClick={() => this.setState({memory: true})}>
              <Img src="/images/memory.png"/>
            </div>}
            { !locked && !softMode && <div className="play-mirror play-interact" onClick={() => this.setState({mirror: true})}>
              <Img src="/images/mirror.png"/>
            </div>}
            {
              (() => {
                let levelstory = [2, 4, 7, 8, 9, 10];
                let cutscenestory = ["boss1", "boss2", "boss3-1", "boss3-2", "sexy9", "sexy10"];
                for (let i = 0; i < levelstory.length; i++) {
                  let lv = levelstory[i];
                  let cs = cutscenestory[i];
                  if (!locked && !softMode && User.data.level >= lv && cutscenes[this.state.champion]["story"][cs] && !User.hasSeen(cutscenes[this.state.champion]["story"][cs].key))
                    return <div key="play-story" className="play-duel play-interact" onClick={() => {
                          this.cutsceneManager.callback = () => this.setState({cutscene: null})
                          this.cutsceneManager.start(cutscenes[this.state.champion]["story"][cs]);
                        } }>
                      <Img src="/images/story.png"/>
                    </div>
                }

                let maxProgress = 3;
                if (User.champion !== 5)
                  maxProgress = 4;
                if (User.data.level === User.data.maxLevel && User.data.progress < maxProgress)
                  return <div key="play-duel" className="play-duel play-interact" onClick={() => {
                    if (eventRuns.length > 0)
                      this.setState({noRun: eventRuns.length-1, deck: eventRuns[eventRuns.length-1].deck.map(card => Object.assign({}, card))});
                    else
                      this.setState({warning: read('menu/storyfightmissingdeckwarning'), warninginfo: read('menu/storyfightmissingdeckinfo')});
                  } }>
                    <Img src="/images/duel.png"/>
                  </div>
              })()
            }

          </div>
          <div className="play-buttons">
            {
              locked && <div className="character-patreon">
                <div className="soon-available">Soon available</div>
                <div className="patreon-redirect" onClick={() => window.open("https://www.patreon.com/NeiNalen", '_blank')}>Get now on Patreon</div>
              </div>
            }
            { !locked && <MenuButton onClick={() => this.embark()}>{ read('menu/newrun') }</MenuButton> }
            { !locked && matchingCurrentRun ? <MenuButton onClick={() => this.continueRun()} to="/game">{ read('menu/continuerun') }</MenuButton> : "" }
            { !locked && matchingCurrentRun ? <MenuButton onClick={() => this.requestAbandonRun()}>{ read('menu/abandonrun') }</MenuButton> : "" }
            { !locked && <MenuButton to="/collection">{read('menu/collection')}</MenuButton> }
            { !locked && User.metCelestials().length > 0 && <MenuButton to="/pantheon">{read('menu/traits')}</MenuButton> }
            { !locked && <MenuButton to="/gallery">{read('menu/gallery')}</MenuButton> }
            { !locked && <MenuButton to="/milestones">{read('menu/milestones')}</MenuButton> }
            { !locked && <MenuButton to="/progress">{read('menu/stats')}</MenuButton> }
          </div>
        </div>
        <div className={"embark-mask" + (this.state.embarking ? " embarking" : "")}>
          <div className="embark-shrink">
          {
            shrinkChibis.map((chibi,i) => <img style={{transform: "scale(" + champions[champion-1].scale[i+minShrinkChibiIndex].value + ")"}} className={"embark-shrink-chibi shrink-" + (i+1) + "-" + shrinkChibis.length} key={i} src={chibi.img}/>)
          }
          <DomLink ref={this.domlink} to="/game"></DomLink>
          </div>
        </div>
        {
          !locked && this.state.noRun !== null ?
          <div className="progress-run">
            <div className="progress-run-title">{read('menu/storybattle')}</div>
            <div id="select-deck-challenge" className="progress-run-subtitle">{read('menu/storybattledecktitle')}</div>
            <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "select-deck-challenge"} target="select-deck-challenge" toggle={() => this.toggleTooltip("select-deck-challenge")}>{read('menu/storybattledeckinfo')}</Tooltip>
            <div className="progress-run-stats">
              <div className="progress-run-stat progress-run-companion">{ eventRuns[this.state.noRun].companion && <Img src={Library.getCompanion(eventRuns[this.state.noRun].companion).img}/> }</div>
              <div className="progress-run-stat">{ read('scene/decksize') + ": " + deckSize(this.state.deck) }</div>
              <div className="progress-run-stat story-min-deck-size"><Img src="/images/entropy.png"/><span>{eventRuns[this.state.noRun].minDeckSize}</span></div>
              <div className="progress-run-stat progress-run-relics">
                { (eventRuns[this.state.noRun].relics || []).map((key, i) => <Img key={i} src={Library.upgradeItem(Library.getRelic(key), eventRuns[this.state.noRun].power || 1).img}/>) }
              </div>
            </div>
            <DeckViewer deck={this.state.deck.map(c => {
              let card = Library.getUpgradedCard(c.key);
              /*if (User.data.upgrades[c.key])
                card = Object.assign({}, card, card.upgrades[User.data.upgrades[c]-1]);*/
              return { card, status: c.status };
              })}
              onClose={() => this.setState({noRun: null, deck: null})}
              info={true}
              onSelect={i => {
                if (Library.getUpgradedCard(this.state.deck[i].key).locked)
                  return;
                if (this.state.deck[i].status !== "disabled" && (!countsTowardsDeckSize(this.state.deck[i]) || deckSize(this.state.deck) > eventRuns[this.state.noRun].minDeckSize))
                  this.state.deck[i].status = "disabled";
                else if (this.state.deck[i].status === "disabled")
                  this.state.deck[i].status = "enabled";
                else return;
                this.setState({deck: this.state.deck});
            }}/>
            { eventRuns.length > this.state.noRun + 1 ? <div onClick={() => this.setState({noRun: this.state.noRun + 1, deck: eventRuns[this.state.noRun+1].deck.map(card => Object.assign({}, card)) })} className="cardbox-arrow cardbox-arrow-left"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
            { this.state.noRun > 0 ? <div onClick={() => this.setState({noRun: this.state.noRun - 1, deck: eventRuns[this.state.noRun-1].deck.map(card => Object.assign({}, card)) })} className="cardbox-arrow cardbox-arrow-right"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
            <div className="progress-run-button">
              {
                this.state.memory ?
                <MainButton onClick={() => this.challengeMemory()}>{read('menu/storyfight')}</MainButton> :
                <MainButton onClick={() => this.challenge()}>{read('menu/storyfight')}</MainButton>
              }
            </div>
          </div> : ""
        }
        {
          this.state.cutscene ?
          <Cutscene back={() => this.cutsceneManager.back()} skip={() => this.cutsceneManager.skip()} continue={() => this.cutsceneManager.continue()} src={this.state.cutscene}/> : ""
        }
      </div>
    );
  }
}

